package io.jsonize.web.services

actual fun logAnalyticsEvent(name: String, params: Map<String, String>) {
    val windowObj = js("window")
    val logger = windowObj?.jsonizeLogEvent
    if (logger == null) return
    try {
        if (params.isEmpty()) {
            logger(name)
        } else {
            val paramsObj = js("({})")
            params.forEach { (key, value) ->
                paramsObj.asDynamic()[key] = value
            }
            logger(name, paramsObj)
        }
    } catch (_: dynamic) {
        // ignore
    }
}
